import Reveal from "./Reveal";

const STEPS = [
  { n: "01", title: "Consultation", text: "Understanding your requirements, space and design preferences." },
  { n: "02", title: "Design & Planning", text: "Concepts, drawings and specifications developed around you." },
  { n: "03", title: "Material Selection", text: "Choosing hardwoods, finishes, fabrics and hardware." },
  { n: "04", title: "Manufacturing", text: "Handcrafted by skilled artisans with rigorous quality checks." },
  { n: "05", title: "Finishing", text: "Careful polishing and detailing to achieve the desired look." },
  { n: "06", title: "Delivery & Installation", text: "Safe delivery and professional installation, ready to be enjoyed." },
];

export default function Craft() {
  return (
    <section id="craft" data-testid="craft-section" className="bg-oxblood-deep py-28 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-brass-soft text-xs tracking-[0.45em] uppercase mb-6">The Craft</p>
          <h2 className="font-display text-ivory text-4xl md:text-6xl leading-tight max-w-3xl">
            Made in our own factory — <em className="text-brass-soft font-light">never outsourced.</em>
          </h2>
          <p className="mt-8 text-ivory/60 font-light leading-relaxed max-w-2xl text-base">
            Behind every creation is our own workshop, where traditional woodworking meets modern
            machinery and uncompromising quality control. From cutting and joinery to polishing —
            every stage stays in our hands.
          </p>
        </Reveal>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ivory/10 border border-ivory/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05} className="bg-oxblood-deep">
              <div
                data-testid={`craft-step-${s.n}`}
                className="group p-8 md:p-10 h-full hover:bg-oxblood transition-colors duration-500"
              >
                <span className="font-display text-brass/50 group-hover:text-brass text-xl transition-colors duration-500">{s.n}</span>
                <h3 className="mt-6 font-display text-ivory text-2xl">{s.title}</h3>
                <p className="mt-4 text-ivory/55 font-light text-sm leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
